import { z } from "zod";

export const SectionSchema = z.object({
  id: z.number(),
  name: z.string().trim().min(1),
  description: z.string(),
  course_id: z.number(),
  links: z.any().nullable(),
});


export type Section = z.infer<typeof SectionSchema>;
const SectionInitStateSchema = z.object({
  sectionsList: z.array(SectionSchema),
  currentSections: SectionSchema.nullable(),
  currentId: z.number().nullable(),
  loadingSubmit: z.boolean(),
 totalCount:z.any()

});

export type SectionModel = z.infer<typeof SectionSchema>;
export type SectionsInitState = z.infer<typeof SectionInitStateSchema>;
